import { render, staticRenderFns } from "./filter-item.vue?vue&type=template&id=1488fef8&scoped=true&"
import script from "./filter-item.vue?vue&type=script&lang=js&"
export * from "./filter-item.vue?vue&type=script&lang=js&"
import style0 from "./filter-item.vue?vue&type=style&index=0&id=1488fef8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1488fef8",
  null
  
)

export default component.exports